module.exports = __webpack_public_path__ + "static/img/goods-merchandise1.b56ac2c4.jpg";